module.exports = __webpack_public_path__ + "img/equipos-moviles-img-5.0640472a.jpg";